import client from '@/api/client.js'
import store from "@/store";
export default {
    methods: {
        async getEmploymentList() {
            var response = await client().get(store.state.apiRouteRoot + "employment", { meta: { clientApiMethod: 'getEmploymentList' } })
            return response?.data;
        },
        async getEmploymentListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getEmploymentListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Employment/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getEmployment(employmentId) {
            var meta = { clientApiMethod: 'getEmployment', input: { employmentId: employmentId } }
            var response = await client().get(store.state.apiRouteRoot + "Employment/" + employmentId, { meta: meta })
            return response?.data;
        },
        async createEmployment(newEmployment) {
            var meta = {
                clientApiMethod: 'createEmployment',
                input: { newEmployment }
            }
            var response = await client().put(store.state.apiRouteRoot + 'Employment', newEmployment, { meta: meta })
            return response?.data;
        },
        async changeEmployment(updatedEmployment) {
            var meta = {
                clientApiMethod: 'changeEmployment',
                input: { updatedEmployment }
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Employment', updatedEmployment, { meta: meta })
            return response?.data;
        },
        async deleteEmployment(employmentId) {
            var meta = {
                clientApiMethod: 'deleteEmployment',
                input: { employmentId }
            }
            var response = await client().delete(store.state.apiRouteRoot + "Employment/" + employmentId, { meta: meta })
            return response?.data;
        },
    }
}